
import Vue from 'vue';
import { Data as Tag } from '@root/modules/tags/types/tag';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';

interface Props {
  tag: Tag | undefined;
}

interface Computed {
  links: Array<any>;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    LinkHandler,
  },
  props: {
    tag: {
      type: Object,
      required: false,
      default: () => undefined,
    },
  },
  computed: {
    links() {
      const links: any[] = [];
      const { locale } = this.$channelConfig('settings');
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;

      // Root link
      links.push({ name: 'Delfi', href: `/`, position: 1 });

      // Topics page link
      links.push({ name: this.$t('tags.title'), href: `/${this.$t('tags.link')}/`, position: 2 });

      // Tag Link
      if (this.tag) {
        const tagUrl = this.$options.filters!.tagUrl({ tag: this.tag, locale, fakeDomainEnabled });
        links.push({ name: this.tag.name, href: tagUrl, position: 3 });
      }

      return links;
    },
  },
});
